import React from "react";
import Accordion, {
  AccordionItem,
  AccordionTitle,
  AccordionContent,
} from "../Accordion";

const AccordionWrap = () => {
  return (
    <div className="agency-accordion max-mb-n30">
      <Accordion>
        <AccordionItem id="one">
          <AccordionTitle id="one">
            Dear Students, Explorers, and Future Innovators, Welcome to XCEL
            Global — where brilliance meets opportunity. In a world shaped by
            technology, creativity, and resilience, we believe that your ideas
            matter. Whether you&apos;re building robots, solving equations,
            painting visions, or launching bold innovations, you are not just
            participating — you are shaping the future.
            <br />
            <br />
            Our mission is to create a global stage where young minds from every
            background can connect, compete, and collaborate. XCEL isn&apos;t
            just a competition — it&apos;s a journey of discovery, leadership,
            and courage. It&apos;s where your passion meets purpose. To each of
            you stepping forward to represent your school, your country, or your
            dream — remember: greatness begins with the decision to try. You
            belong in the arena of changemakers, and we are proud to stand
            beside you as you rise.
            <br />
            <br />
            Keep pushing boundaries. Keep asking questions. Keep building
            what&apos;s next. With pride and belief in your potential,
          </AccordionTitle>
        </AccordionItem>
        <AccordionItem id="two">
          <AccordionTitle id="two">President</AccordionTitle>
          <AccordionContent id="two">
            Mr. Salim Joldoshov is an experienced educator and international
            program leader with extensive experience in academia and IT
            infrastructure. A distinguished alumnus of the Georgia Institute of
            Technology, he has also actively contributed to numerous social and
            philanthropic initiatives across major cities in Texas.
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </div>
  );
};

export default AccordionWrap;
